import {
  getData,
  postData,
  getFileData,
  convertPageModel,
  getDataCache
} from './api-base.service'
import {
  getStore,
  formatTimeFromInt60
} from '../config/mUtils'
import { post } from 'jquery';

const baseUrl = process.env.VUE_APP_BASE_API;

// #region Global Settings
export const getGlobalSettingValuesByTypeList = (typeList) => {
  let data = typeList;
  let result = postData('/Common/GetGlobalSettingValuesByTypeList', data);
  return result;
}

export const saveGlobalSettingValuesByType = (data) => {
  let result = postData('/Common/SaveGlobalSettingValuesByType', data);
  return result;
}

export const getGlobalSettingValueByType = (type) => {
  let data = {type};
  let result = getData('/Common/GetGlobalSettingValueByType', data);
  return result;
}

export const saveGlobalSettingValueByType = (type, value) => {
  let data = value;
  let result = postData(`/Common/SaveGlobalSettingValueByType?type=${type}`, data);
  return result;
}
// #endregion

export const sendSMS = (phone, type = 1) => {
  let data = {
    Phone: phone,
    SMSType: type
  };
  let result = postData('/SMS/SendSMS', data, false);
  return result;
}

export const validateSMSCode = (phone, code, type = 0) => {
  let data = {
    Phone: phone,
    Code: code,
    SMSType: type
  };
  let result = postData('/SMS/ValidateSMSCode', data, false);
  return result;
}

export const getMemberCardConfig = () => {
  return getData('/Common/GetMemberCardConfig');
}

export const getAllUniversities = () => {
  let result = getData('/Common/GetAllUniversities', {}, false);
  return result;
}

export const getUniversities = (hasStudent) => {
  if (typeof hasStudent == undefined){
    hasStudent = false;
  }
  let result = getData('/Common/GetUniversities', {hasStudent: hasStudent});
  return result;
}

export const getUniversityDataList = (hasStudent) => {
  if (typeof hasStudent == undefined){
    hasStudent = false;
  }
  let result = getData('/Common/GetUniversityDataList', {hasStudent: hasStudent});
  return result;
}

export const getUniversityList = () => {
  let result = getData('/Common/GetUniversityList');
  return result;
}

export const getCourseCategoryList = (courseType, haveOptions = null) => {
  let data = {
    courseType: courseType,
    haveOptions: haveOptions
  };
  let result = getData('/Common/GetCourseCategoryList', data);
  return result;
}

export const getAllCourseCategoryList = (removeNormalClass) => {
  let data = {removeNormalClass: !!removeNormalClass};
  let result = getData('/Common/GetAllCourseCategoryList', data);
  return result;
}

export const getCourseCategoryOptionList = (categoryIds) => {
  let data = {
    categoryIds: categoryIds
  };
  let result = getData('/Common/GetCourseCategoryOptionList', data);
  return result;
}

export const getUniversityGroupCourseCategoryOptionGroupList = (courseCategoryId, universityGroupNumber = null) => {
  let data = {
    courseCategoryId: courseCategoryId,
    universityGroupNumber: universityGroupNumber
  };
  let result = getData('/Common/GetUniversityGroupCourseCategoryOptionGroupList', data);
  return result;
}

export const saveCourseCategoryOptions = (models) => {
  let data = models;
  let result = postData('/Common/SaveCourseCategoryOptions', data);
  return result;
}

export const saveCourseCategoryOptionsPrice = (models) => {
  let data = models;
  let result = postData('/Common/SaveCourseCategoryOptionsPrice', data);
  return result;
}

export const saveUniversityGroupCourseCategoryOptions = (models) => {
  let data = models;
  let result = postData('/Common/SaveUniversityGroupCourseCategoryOptions', data);
  return result;
}

export const getUniversityGroups = (getAll, filterByCourse, termId = null) => {
  if (typeof getAll == undefined) {
    getAll = false;
  }
  if (typeof filterByCourse == undefined) {
    filterByCourse = false;
  }
  let result = getData('/Common/GetUniversityGroups', {
    getAll: getAll,
    filterByCourse: filterByCourse,
    termId
  });
  return result;
}

export const getUniversityPageData = (model) => {
  let data = convertPageModel(model);

  var fetchResult = postData('/Common/GetUniversityPageData', data);

  return fetchResult;
}

export const getUniversityByGroup = (universityGroup) => {
  let result = getData('/Common/GetUniversityByGroup', {
    universityGroup: universityGroup
  });
  return result;
}

export const getNoneGroupUniversity = () => {
  let result = getData('/Common/GetNoneGroupUniversity');
  return result;
}

export const saveUniversityGroups = (universityList, removeList) => {
  let data = {
    Universities: universityList,
    RemoveList: removeList
  }
  let result = postData("/Common/SaveUniversityGroups", data);
  return result;
}

export const saveUniversity = (model) => {
  let data = model;

  let result = postData("/Common/SaveUniversity", data);

  return result;
}

export const getTeachers = (planId) => {
  let result = getData('/Common/GetTeachers', {
    planId: planId
  });
  return result;
}

export const getTermTeachers = (termId, universityGroupNumber) => {
  let result = getData('/Common/GetTermTeachers', {
    termId,
    universityGroupNumber
  });
  return result;
}

export const getAllTerchers = () => {
  let result = getData('/Common/GetAllTeachers');
  return result;
}

export const getAllTrainingTeacher = (courseType) => {
  let result = getData('/Common/GetAllTrainingTeacher', {
    courseType: courseType
  });
  return result;
}

export const uploadFile = (data) => {
  let result = postData('/Common/Upload', data);
  return result;
}

export const getUploadUrl = () => {
  return baseUrl + "/Common/Upload";
}

export const getUploadHeader = () => {
  let token = getStore('auth_token');
  return {
    'Authorization': 'Bearer ' + token
  }
}

export const getTerms = (getNextTerm, getByUser, includeReviewCourse, studentId) => {
  if (typeof getNextTerm == "undefined") {
    getNextTerm = false;
  }
  if (typeof getByUser == "undefined") {
    getByUser = false;
  }
  if (typeof includeReviewCourse == "undefined") {
    includeReviewCourse = false;
  }
  if (typeof studentId == "undefined") {
    studentId = null;
  }
  let data = {
    getNextTerm: getNextTerm,
    getByUser: getByUser,
    includeReviewCourse: includeReviewCourse,
    studentId: studentId
  };
  let result = getData('/Common/GetTerms', data);
  return result;
}

export const getTrainingTerms = (getNextTerm, trainingCategoryId, getByUser) => {
  if (typeof getNextTerm == "undefined") {
    getNextTerm = false;
  }
  if (typeof getByUser == "undefined") {
    getByUser = false;
  }
  let data = {
    getNextTerm: getNextTerm,
    trainingCategoryId: trainingCategoryId,
    getByUser: getByUser
  };
  let result = getData('/Common/GetTrainingTerms', data);
  return result;
}

export const getCurrentTerm = (termType, trainingCategoryId) => {
  if (typeof termType == undefined){
    termType = 1;
  }
  if (typeof trainingCategoryId == undefined){
    trainingCategoryId = null;
  }
  let result = getData('/Common/CurrentTerm', {termType: termType, trainingCategoryId: trainingCategoryId});
  return result;
}

export const sendEmail = (to, cc, emailType) => {
  let data = {
    ToEmail: to,
    CCToEmail: cc,
    EmailType: emailType
  }
  let result = postData('/Email/Send', data);
  return result;
}

export const resetTerm = () => {
  //let data = {startDateText:startDate, endDateText: endDate};
  let result = getData('/Common/ResetTerm');
  return result;
}

export const resetTrainingTerm = (id) => {
  let data = {
    id: id
  };
  let result = getData('/Common/ResetTrainingTerm', data);
  return result;
}

export const getFile = (id) => {
  let result = getFileData('/Common/GetFile', {
    id: id
  });
  return result;
}

export const getSupplementVideoTypeList = () => {
  let result = getData('/Common/GetSupplementVideoTypeList');
  return result;
}

export const SyncGoogleSheet = () => {
  let result = getData("/Common/SyncGoogleCoursePrice");
  return result;
}

export const getWeChatGroupTypeList = () => {
  let result = getData('/Common/GetWeChatGroupTypeList');
  return result;
}

export const getCourseSelections = (studentId) => {
  return getData('/Common/GetCourseSelections', {studentId: studentId});
}

export const getCourseCodeList = (universityGroup, termId) => {
  if (isNaN(universityGroup)) {
    universityGroup = 0;
  }
  if (isNaN(universityGroup)) {
    termId = null;
  }
  let result = getData('/Common/GetCourseCodeList', {
    universityGroup: universityGroup,
    termId: termId
  });
  return result;
}

export const getCourseCodeListByUniversityId = (universityId, termId) => {
  if (isNaN(universityId)) {
    universityId = 0;
  }
  if (isNaN(universityId)) {
    termId = null;
  }
  let result = getData('/Common/GetCourseCodeListByUniversityId', {
    universityId: universityId,
    termId: termId
  });
  return result;
}

export const saveCampus = (id, name, longitude, latitude, timezone, schedules) => {
  let data = {
    Id: id,
    Name: name,
    Longitude: longitude,
    Latitude: latitude,
    timezone: timezone,
    CampusTimeSchedules: []
  };

  schedules.forEach(element => {
    let id = 0;
    if (!!element.dataId)
      id = element.dataId;

    let dayofweek = element.day;
    if (dayofweek == 7)
      dayofweek = 0;
    let item = {
      Id: id,
      CampusId: element.campusId,
      DayOfWeek: dayofweek,
      StartTimeText: formatTimeFromInt60(element.startTime),
      EndTimeText: formatTimeFromInt60(element.endTime)
    };
    data.CampusTimeSchedules.push(item);
  });

  let result = postData("/Common/SaveCampus", data);

  return result;
}

export const removeCampus = (id) => {
  let result = getData('/Common/RemoveCampus', {
    id: id
  });
  return result;
}

export const getCampusList = () => {
  let result = getData('/Common/GetCampusList');
  return result;
}

export const getCourseCampusList = (courseId) => {
  let result = getData('/Common/GetCourseCampusList', {
    courseId: courseId
  });
  return result;
}

export const getVideoAppCampusList = (courseId) => {
  let result = getData('/Common/GetVideoAppCampusList', {
    courseId: courseId
  });
  return result;
}

export const getCampusPageList = (data) => {
  let result = postData('/Common/GetCampusPageList', {
    data: data
  });
  return result;
}

export const getCourseTypeList = () => {
  let result = getData('/Common/GetCourseTypeList');
  return result;
}

export const getAllTerms = (termType) => {
  let data = {
    termType: termType
  }

  return getData("/TermManage/GetAllTerms", data);
}

export const getTrainingCategoryList = (courseType, getByUser, getAll) => {
  if (typeof getByUser == "undefined") {
    getByUser = false;
  }
  if (typeof getAll == undefined) {
    getAll = false;
  }
  return getData("/Common/GetTrainingCategoryList", {
    courseType: courseType,
    getByUser: getByUser,
    getAll: getAll
  });
}

export const getTrainingCourseList = (data) => {
  return getData("/Common/GetTrainingCourseList", data);
}

export const getAllCurrentTermTrainingEnglishCourses = () => {
  return getData("/Common/GetAllCurrentTermTrainingEnglishCourses");
}

export const getTeacherEnglishTrainings = () => {
  return getData("/Common/GetTeacherEnglishTrainings");
}

export const getMemberShipYears = (count) => {
  let result = getData('/Common/GetMemberShipYears', {
    count: count
  });
  return result;
}

export const getComputerList = () => {
  let result = getData('/Common/GetComputerList');
  return result;
}

export const getComputerListByCampusId = (campusId) => {
  let data = {
    campusId: campusId
  };
  let result = getData('/Common/GetComputerListByCampusId', data);
  return result;
}
export const saveComputer = (id, computerName, isActive, campusId, schedules = null, removeScheduleIds = null) => {
  if (typeof id == 'undefined' || id == null || id == "") {
    id = 0;
  }
  let data = {
    Id: id,
    ComputerName: computerName,
    CampusId: campusId,
    isActive: isActive
  };
  if (!!schedules && schedules.length > 0) {
    let cutSchedules = [];
    schedules.forEach(function (item, index) {
      cutSchedules.push({
        Id: item.dataId,
        ComputerId: id,
        StartDateText: `${item.dateRange[0].getFullYear()}/${item.dateRange[0].getMonth() + 1}/${item.dateRange[0].getDate()}`,
        EndDateText: `${item.dateRange[1].getFullYear()}/${item.dateRange[1].getMonth() + 1}/${item.dateRange[1].getDate()}`,
        StartTimeText: formatTimeFromInt60(item.startTime),
        EndTimeText: formatTimeFromInt60(item.endTime)
      });
    });
    $.extend(data, {
      ComputerUnavailableTimeSchedules: cutSchedules
    });
  }
  if (!!removeScheduleIds && removeScheduleIds.length > 0) {
    $.extend(data, {
      RemoveScheduleIds: removeScheduleIds
    });
  }
  var result = postData('/Common/SaveComputer', data);
  return result;
}

export const removeComputer = (id) => {
  let result = getData('/Common/RemoveComputer', {
    id: id
  });
  return result;
}

export const getFileContainerList = () => {
  return getData("/Common/GetFileContainerList");
}

export const getUniversitySupplementVideoPriceSetting = (id) => {
  let data = {
    id: id
  }
  return getData('/Common/GetUniversitySupplementVideoPriceSetting', data);
}

export const getUniversityVideoPriceSettingList = () => {
  return getData('/Common/GetUniversityVideoPriceSettingList');
}

export const getUniversitySupplementVideoPriceSettingByUniversityGroupNumber = (groupNumber) => {
  let data = {
    groupNumber: groupNumber
  }
  return getData('/Common/GetUniversitySupplementVideoPriceSettingByUniversityGroupNumber', data);
}

export const saveUniversityVideoPriceSettings = (data) => {
  return postData('/Common/SaveUniversityVideoPriceSettings', data);
}

export const getUniversityWatchingDurationSettingList = () => {
  return getData('/Common/GetUniversityWatchingDurationSettingList');
}

export const saveUniversityWatchingDurationSettings = (data) => {
  return postData('/Common/SaveUniversityWatchingDurationSettings', data);
}

export const getAdvertistings = () => {

}

export const getScoreList = () => {
  return getData('/Common/GetScoreList', );
}


export const getCategoryCampusList = (categoryId) => {
  return getData('/Common/GetCategoryCampusList', {
    categoryId: categoryId
  });
}

export const getMobileAppLink = () => {
  return getData("/Common/GetMobileAppLink");
}

export const getWeChatConfig = () => {
  var result = getData('/Common/GetWeChatConfig');
  return result;
}

export const getAdvanceEnrollmentComments = (universityId) => {
  let result = getData('/Common/GetAdvanceEnrollmentComments', {
    universityId: universityId
  });
  return result;
}

export const getCampusTaxRate = (campusId) => {
  return getData("/Common/GetCampusTaxRate", {
    campusId: campusId
  });
}

export const getCampusTaxRateList = () => {
  return getData("/Common/GetCampusTaxRateList");
}

export const saveCampusTaxRates = (data) => {
  return postData("/Common/SaveCampusTaxRates", data);
}

export const getReviewCourseActivations = (courseId) => {
  let data = {
    courseId: courseId
  };
  let result = getData('/Common/GetReviewCourseActivations', data);
  return result;
}

export const getCourseActivationNamesData = (courseIds) => {
  let result = postData('/Common/GetCourseActivationNamesData', courseIds);
  return result;
}

export const getReviewCourseActivationData = (courseIds) => {
  let result = postData('/Common/GetReviewCourseActivationData', courseIds);
  return result;
}

export const getCourseActivations = (courseId) => {
  let data = {
    courseId: courseId
  };
  let result = getData('/Common/GetCourseActivations', data);
  return result;
}

export const getUniversityGroupSettings = () => {
  let result = getData('/Common/GetUniversityGroupSettings');
  return result;
}

export const saveUniversityGroupSettings = (data) => {
  let result = postData('/Common/SaveUniversityGroupSettings', data);
  return result;
}

export const saveClientSideError = (action, message) => {
  let data = {
    Action: action,
    Message: message
  };

  return postData("/Common/SaveClientSideError", data);
}

export const getOpenCoursePageList = (model) => {
  let data = convertPageModel(model);
  return postData(`/Common/GetOpenCoursePageList`, data);
}

export const removeOpenCourse = (id) => {
  return getData(`/Common/RemoveOpenCourse`, {id: id});
}

export const saveOpenCourse = (data) => {
  return postData('/Common/SaveOpenCourse', data)
}

export const getCountryList = () => {
  let result = getData('/Common/GetCountryList');
  return result;
}

export const getCurrencyList = () => {
  let result = getData('/Common/GetCurrencyList');
  return result;
}

export const getCourseClassGradeList = () => {
  let result = getData('/Common/GetCourseClassGradeList');
  return result;
}

export const checkActiveOpenCourse = () => {
  return getData(`/Common/CheckActiveOpenCourse`);
}

export const getEnableAutonomousEnrolmentSetting = () => {
  return getData(`/Common/GetEnableAutonomousEnrolmentSetting`);
}

// #region AutonomousPayment
export const getPayApiType = () => {
  let result = getData('/Common/GetPayApiType');
  return result;
}

export const createPaymentOrder = (data) => {
  let result = postData('/Common/CreatePaymentOrder', data);
  return result;
}

export const createPaymentRefund = (workflowId) => {
  let data = {workflowId};
  let result = getData('/Common/CreatePaymentRefund', data);
  return result;
}
// #endregion

// #region Checkpay
export const getCheckpaySettingItems = () => {
  let result = getData('/Common/GetCheckpaySettingItems');
  return result;
}
// #endregion

// #region AlphaPay
export const getAlphaPaySettingItems = () => {
  let result = getData('/Common/GetAlphaPaySettingItems');
  return result;
}

export const getAlphaPayOrderRecordByWorkflowId = (workflowId) => {
  let data = {workflowId};
  return getData('/Common/GetAlphaPayOrderRecordByWorkflowId', data);
}
// #endregion

export const generateCode = (codeType) => {
  return getData('/Common/GenerateCode', {codeType: codeType});
}

export const getUniversityEmailAccount = () => {
  return getData('/Common/GetUniversityEmailAccount');
}

export const getStudentGradeList = () => {
  return getData('/Common/GetStudentGradeList');
}

export const getTeacherGradeList = () => {
  return getData('/Common/GetTeacherGradeList');
}

export const getIntroducers = (universityGroup) => {
  return getData('/Common/GetIntroducers', {universityGroup: universityGroup});
}

export const getPreCurrentTerms = (termType, trainingCategoryId) => {
  let result = getData('/Common/GetPreCurrentTerms', {termType: termType, trainingCategoryId: trainingCategoryId});
  return result;
}


// WEBPACK FOOTER //
// ./src/service/common.service.js